/*  MUI  */
import { TableBody, TableRow } from '@mui/material';

/*  React  */
import React from 'react';

/* Internal Components */
import { ManagedTableEmptyRows } from './ManagedTableEmptyRows';

export const ManagedTableRows = ({
    colSpan,
    emptyRowsMessage,
    manageRows,
    renderBody,
    renderBodyKey,
    renderRows,
    rowHeight,
    searchEnabled,
    searchText
}) => (
    <TableBody data-testid="managedTableTableBody">
        {renderRows?.length ? (
            renderRows.map((row) => {
                let key = row.id || Math.random();
                if (renderBodyKey) {
                    if (row[renderBodyKey]) {
                        key = row[renderBodyKey];
                    }
                }
                if (manageRows) {
                    return (
                        <React.Fragment key={key}>
                            {renderBody(row)}
                        </React.Fragment>
                    );
                }
                return (
                    <TableRow
                        data-testid="managedTableTableRow"
                        key={key}
                        sx={{
                            backgroundColor: 'table.rowBackground',
                            maxHeight: rowHeight,
                            overflow: 'hidden'
                        }}
                    >
                        {renderBody(row)}
                    </TableRow>
                );
            })
        ) : (
            <ManagedTableEmptyRows
                colSpan={colSpan}
                emptyRowsMessage={emptyRowsMessage}
                searchEnabled={searchEnabled}
                searchText={searchText}
            />
        )}
    </TableBody>
);
